"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Claims_1 = require("../components/Claims/Claims");
var targetNode = document.querySelector('.claims-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Claims_1.default, null), targetNode);
}
